import { Component, Inject, Injector, ChangeDetectionStrategy } from "@angular/core";
import { FormControl } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material/dialog";
import { AbstractComponent, AttendanceService, ContactService, Department, DepartmentService, Team, TeamService, User } from "lib-trend-core";
import { Validators } from "ngx-editor";
import { debounceTime } from "rxjs";

@Component({
    selector: 'contact-customer-portfolio-transfer-component',
    templateUrl: './contact-customer-portfolio-transfer.v2.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ContactCustomerPortfolioTransferComponent extends AbstractComponent {

  filterControlDeparment: FormControl = new FormControl('');
  filterControlAttendant: FormControl = new FormControl('');

  attendantList: Array<User> = new Array<User>();
  allAttendant: Array<User> = new Array<User>();

  departmentsList: Array<Department> = new Array<Department>();
  allDepartments: Array<Department> = new Array<Department>();

  constructor(
    injector: Injector,
    public departmentService: DepartmentService,
    public teamService: TeamService,
    public contactService: ContactService,
    @Inject(MAT_DIALOG_DATA) public data: string[],
    private matDialogRef: MatDialogRef<ContactCustomerPortfolioTransferComponent>,
  ) {
    super(injector);
  }

  ngOnInit(): void {
    this.createForm();
    this.loadDepartments();
    this.fetchFilterDepartments();
    this.fetchFilterAttendant();
  }

  protected createForm(): void {
    this.formGroup = this.formBuilder.group({
      attendant: [null, Validators.required],
      department: [null, Validators.required],
    });
  }

  changeDepartment() {
    this.loadAttendant();
  }

  private loadDepartments() {
    this.departmentService.getList().subscribe({
      next: (departments: Array<Department>) => {
        this.departmentsList = departments;
        this.allDepartments = departments;
      },
      error: (err) => this.alertService.error(err.error.message),
    });
  }

  loadAttendant() {
    const idDepartment = this.formGroup.get('department')?.value;
    if (!idDepartment) {
      this.attendantList = [];
      this.allAttendant = [];
      return;
    }
    this.teamService.getByDepartment(idDepartment).subscribe({
      next: (teams: Team[]) => {
        if (teams.length > 0) {
          this.attendantList = teams[0].agents;
          this.allAttendant = teams[0].agents;
        } else {
          this.attendantList = [];
          this.allAttendant = [];
        }
      },
      error: (err) => this.alertService.error(err.error.message),
    });
  }

  private fetchFilterDepartments(): void {
    this.filterControlDeparment.valueChanges.pipe(
      debounceTime(300),
    ).subscribe((value: string) => {
      const currentValue = this.formGroup.get('department')?.value || null;

      this.allDepartments = this.departmentsList.filter(department =>
        department.name.toLowerCase().includes(value.toLowerCase()) &&
        department._id !== currentValue
      );

      const existingDepartment = this.departmentsList.find(department => department._id === currentValue);
      if (existingDepartment) {
        this.allDepartments.push(existingDepartment);
      }
    });
  }

  private fetchFilterAttendant(): void {
    this.filterControlAttendant.valueChanges.pipe(
      debounceTime(300),
    ).subscribe((value: string) => {
      const currentValue = this.formGroup.get('attendant')?.value || null;

      this.allAttendant = this.attendantList.filter(attendant =>
        attendant.name.toLowerCase().includes(value.toLowerCase()) &&
        attendant._id !== currentValue
      );

      const existingAttendant = this.attendantList.find(attendant => attendant._id === currentValue);
      if (existingAttendant) {
        this.allAttendant.push(existingAttendant);
      }
    });
  }

  save() {
    if (this.formGroup.invalid) {
      this.formGroup.markAllAsTouched();
      return;
    }

    const idDepartment = this.formGroup.get('department')?.value;
    const idAttendant = this.formGroup.get('attendant')?.value;



    this.contactService.transferContactsCustomerPortfolio(idDepartment, idAttendant, this.data).subscribe({
      next: () => {
        this.alertService.success(this.t('contact.customerPortfolioTransfer.transferSuccess'));
        this.matDialogRef.close(this.data);
      },
      error: (err) => this.alertService.error(err.error.message),
    });
  }

}
